import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Eyebrow — uppercase micro-label (section eyebrow).
 *
 * Encapsulates the locked Phase 61 typographic cluster from the UI-SPEC
 * (12px / weight 600 / uppercase / tracking-[0.12em] / text-text-dim) in one
 * source so every pipeline + right-rail section label stays in sync.
 *
 * `text-text-dim` is the Phase 60 extension token (globals.css). No hardcoded
 * color — per-clinic accent injection (branding-bootstrap.tsx) stays orthogonal.
 */
function Eyebrow({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="eyebrow"
      className={cn(
        "font-sans text-[10.5px] font-semibold uppercase tracking-[0.13em] text-text-dim",
        className
      )}
      {...props}
    />
  );
}

export { Eyebrow };
